import { faCommentsQuestion } from "@jewlr/pro-regular-svg-icons/faCommentsQuestion"
import { faGem } from "@jewlr/pro-regular-svg-icons/faGem"
import { faGift } from "@jewlr/pro-regular-svg-icons/faGift"
import { Link } from "react-router-dom"

import { SectionList } from "@jewlr/storybook/info"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t, IS_GE_CHECKOUT, IS_NA } from "helpers/application"
// import { showHolidayRma, holidayRmaDates } from "helpers/holiday"
import { showHolidayRma } from "helpers/holiday"

const FormBlock = (props) => (
  <div
    className="tablet:py-54 tablet:px-32 flex flex-col items-center bg-white p-24 text-center"
    {...props}
  />
)

const FormTitle = (props) => (
  <h3 className="text-20 leading-20 mb-24 font-bold" {...props} />
)

const ButtonLink = (props) => (
  <Button
    asChild
    className="text-18 font-medium"
    variant="secondary"
    {...props}
  />
)

const FaqTitle = (props) => (
  <h3 className="text-18 tablet:text-24 leading-30 font-medium" {...props} />
)

const ReturnPolicy = () => {
  const is_na = IS_NA()
  const is_ge_checkout = IS_GE_CHECKOUT()

  return (
    <>
      <div className="contained leading-22 tablet:mb-32 tablet:mx-auto mx-16 mb-24">
        <h1 className="text-32 leading-36 mb-32 mt-16 font-bold">
          Returns & Orders
        </h1>
        {is_ge_checkout ? (
          <>
            <h2 className="text-20 tablet:text-26 leading-20 tablet:leading-30 mb-16 font-medium">
              30-Day Return Policy
            </h2>
            <p>
              JEWLR offers a 30-day return policy. You may return an item for a
              refund (minus Deductions) within 30 days of the original{" "}
              {jewlr_t("terms.shipping")} date if the following conditions are
              met.
            </p>
            <SectionList className="text-16 leading-22 tablet:leading-22 mb-32 font-light tracking-tight text-black">
              <li>
                The item must be returned in a new and unworn condition. New and
                unworn condition means that there are no scratches, marks, or
                blemishes on the items. Items modified or re-sized are not
                considered new.
              </li>
              <li>
                The item must be postmarked within 30 days of the original
                shipment date.
              </li>
              <li>
                Items that have been resized, updated and/or repaired do not
                qualify for a refund.
              </li>
              <li>
                You are responsible for the return {jewlr_t("terms.shipping")}{" "}
                cost and the goods are your responsibility until they reach our
                warehouse.
              </li>
              <li>
                Luxury Bridal Collection items must be shipped to{" "}
                {sl.config.site_title} using Jewlr&apos;s{" "}
                {jewlr_t("terms.shipping")} provider.
              </li>
              <li>
                Promotional gifts must also be returned with your returned item.
              </li>
              <li>
                Your Luxury Bridal Collection diamond report must be returned
                with your One and Only Signature Collection item. $150 will be
                deducted from the Refund for missing or damaged reports.
              </li>
              <li>
                Returns without a JEWLR Return Merchandise Authorization will be
                refused upon receipt.
              </li>
              <li>
                Pendants purchased as a donation to any charitable{" "}
                {jewlr_t("terms.organization")} are not eligible for a refund -
                including, but not limited to, My Everyday Hero pendants.
              </li>
              <li>
                Non-{jewlr_t("terms.jewelry")} and final sale items such as
                {jewlr_t("terms.Jewelry")} Cleaner and{" "}
                {jewlr_t("terms.Jewelry")} Care Cloths are not eligible for a
                refund.
              </li>
              <li>
                Returns with missing paperwork or product will not be processed.
              </li>
            </SectionList>
            <p>
              NOTE: Some special orders are non-returnable. We will inform you
              if an item cannot be returned before going ahead with your order.
            </p>
          </>
        ) : (
          <>
            <h2 className="text-20 tablet:text-26 leading-20 tablet:leading-30 mb-16 font-medium">
              99-Day Return Policy
            </h2>
            <p>
              We want you to feel comfortable and confident when shopping at{" "}
              {sl.config.site_title}. That is why we offer an easy, hassle-free
              99-day return policy. If you are not completely satisfied with
              your purchase you may return it for a full refund (minus any{" "}
              {jewlr_t("terms.shipping")} and/or gift packaging charges, if any)
              within 99 days of the original {jewlr_t("terms.shipping")} date.
              Upon receipt of your return, items are inspected for signs of wear
              or damage. If accepted, refunds will be issued to the original
              form of payment.
            </p>
            <SectionList className="text-16 leading-22 tablet:leading-22 mb-48 font-light tracking-tight text-black">
              <li>
                Any item purchased from {sl.config.site_title} can be returned,
                including engraved items
              </li>
              <li>
                The item(s) must be returned in a new and unworn condition
              </li>
              <li>
                Any promotional gifts must also be returned with your returned
                item
              </li>
              <li>
                Items which have been resized, updated and/or repaired do not
                qualify
              </li>
              <li>
                You will be responsible for the return{" "}
                {jewlr_t("terms.shipping")} cost
              </li>
            </SectionList>
          </>
        )}
      </div>
      <div className="bg-grey-4 tablet:pb-32 tablet:pt-32 pb-8 pt-24">
        <div className="contained tablet:mx-auto mx-16">
          <h2 className="text-26 leading-30 mb-24 text-center font-medium">
            Request Forms
          </h2>
          <p
            className="tablet:text-center mx-auto mb-24"
            style={{ maxWidth: "652px" }}
          >
            Need to make a return or change your order? Use the request forms
            below to get started. For further assistance, please contact
            customer service at{" "}
            <Button asChild text underline variant="secondary">
              <a
                href={`mailto:${sl.config.customer_service_email}`}
                id="customer_service_email"
                rel="noreferrer"
                target="_blank"
              >
                {sl.config.customer_service_email}
              </a>
            </Button>{" "}
            or{" "}
            <Button asChild text underline variant="secondary">
              <a
                href={`tel:${sl.config.customer_service_toll_free}`}
                rel="nofollow"
              >
                {sl.config.customer_service_toll_free}
              </a>
            </Button>
            .
          </p>
          {showHolidayRma() && (
            <div className="border-garnet leading-22 tablet:mb-48 tablet:mx-40 mb-24 rounded-2xl border bg-white px-32 py-24 font-medium tracking-tight">
              Given the high demand during the holiday season, we anticipate
              that repairs or returns may take longer than usual. If your repair
              or return deadline falls within this period, we will adjust the
              date accordingly.
              {/* In order to focus on customer orders and ensure all gifts arrive
              for the holidays, we will not be processing repairs between{" "}
              {holidayRmaDates.start} and {holidayRmaDates.end}. Don&apos;t
              worry &ndash; you&apos;re still covered! We will adjust or extend
              your repair deadline accordingly. Thank you for your understanding
              and cooperation during this busy time.*/}
            </div>
          )}
          <div className="tablet:grid-cols-2 desktop:gap-48 grid grid-cols-1 gap-24">
            <FormBlock>
              <Image
                alt=""
                className="mb-16"
                height="40"
                src={require("images/icons/orders/return.svg")}
                width="40"
              />
              <FormTitle>Request to Return</FormTitle>
              <p className="mb-24">
                Complete this form to return an item you have purchased from{" "}
                {sl.config.site_title} for a refund.
              </p>
              <p className="mb-24">
                To be eligible for a refund, your item(s) must be in a new and
                unworn condition and be within {is_ge_checkout ? "30" : "99"}{" "}
                days of the original {jewlr_t("terms.shipping")} date.
              </p>
              {is_ge_checkout ? (
                <>
                  <ButtonLink>
                    <a
                      data-lc="return-policy"
                      href={`${sl.config.global_e_analytics_url}/returns/portal/mZfW`}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Return Request Form
                    </a>
                  </ButtonLink>
                  <p className="body-sm mt-32 text-left font-semibold">
                    If your order was placed prior to November 10, 2025, please{" "}
                    <Button asChild text underline variant="secondary">
                      <Link data-lc="return-policy" to="/order/return">
                        click here
                      </Link>
                    </Button>{" "}
                    to complete this form.
                  </p>
                </>
              ) : (
                <ButtonLink>
                  <Link data-lc="return-policy" to="/order/return">
                    Return Request Form
                  </Link>
                </ButtonLink>
              )}
            </FormBlock>

            <FormBlock>
              <Image
                alt=""
                className="mb-16"
                height="40"
                src={require("images/icons/orders/repair.svg")}
                width="40"
              />
              <FormTitle>Request to Repair</FormTitle>
              <p className="mb-24">
                Complete this form to submit a request to repair an item
                purchased from {sl.config.site_title}.
              </p>
              <p className="mb-24">
                All {jewlr_t("terms.jewelry")} and watches include a FREE 1-year
                manufacturer&apos;s warranty. We also offer repair services
                beyond the warranty period at an additional cost. For more
                information, please{" "}
                <Button asChild text underline variant="secondary">
                  <Link data-lc="return-policy" to="/info/warranty-information">
                    click here
                  </Link>
                </Button>
                .
              </p>
              <ButtonLink data-lc="return-policy">
                <Link to="/order/repair">Repair Request Form</Link>
              </ButtonLink>
            </FormBlock>

            <FormBlock>
              <Image
                alt=""
                className="mb-16"
                height="40"
                src={require("images/icons/orders/resize.svg")}
                width="40"
              />
              <FormTitle>Request to Resize</FormTitle>
              <p className="mb-24">
                Complete this form to submit a request to resize a ring
                purchased from {sl.config.site_title}.
              </p>
              <p className="mb-24">
                {is_na
                  ? "We offer one FREE resizing within two full sizes of your ring within 30 days of the original shipment date, including engraved items."
                  : "We offer ring resizing for a reasonable fee within 30 days of the original shipment date. This includes items that have engravings."}{" "}
                To determine your correct ring size or for more information,
                please{" "}
                <Button asChild text underline variant="secondary">
                  <Link data-lc="return-policy" to="/info/ring_sizing">
                    click here
                  </Link>
                </Button>
                .
              </p>
              <ButtonLink data-lc="return-policy">
                <Link to="/order/resizing">Resize Request Form</Link>
              </ButtonLink>
            </FormBlock>

            <FormBlock>
              <Image
                alt=""
                className="mb-16"
                height="40"
                src={require("images/icons/orders/change-order.svg")}
                width="40"
              />
              <FormTitle>Request to Change Order</FormTitle>
              <p className="mb-24">
                Complete this form to make a change or adjustment to a current{" "}
                {sl.config.site_title} order in progress.
              </p>
              <p className="mb-24">
                To be eligible to make an order change depends on where in the
                manufacturing process your order is when you make the request.
                Please note that any change may also delay your estimated
                shipment date.
              </p>
              <ButtonLink data-lc="return-policy">
                <Link to="/order/change">Order Change Request Form</Link>
              </ButtonLink>
            </FormBlock>
          </div>
        </div>
      </div>

      <div className="contained tablet:mx-auto tablet:py-80 tablet:text-center px-16 py-32">
        <h2 className="text-26 leading-30 mb-32 text-center font-medium">
          Frequently Asked Questions
        </h2>
        <div className="tablet:grid-cols-3 desktop:gap-24 grid grid-cols-1 gap-16">
          <Link
            className="bg-grey-10 tablet:flex-col tablet:gap-24 tablet:py-80 flex items-center justify-center gap-8 py-24"
            data-lc="return-policy"
            to="/helpdesk/5e9f51622c7d3a7e9aeb5bfc"
          >
            <FontAwesomeIcon
              className="text-32 tablet:text-40"
              icon={faCommentsQuestion}
            />
            <FaqTitle>General Questions</FaqTitle>
          </Link>
          <Link
            className="bg-grey-10 tablet:flex-col tablet:gap-24 tablet:py-80 flex items-center justify-center gap-8 py-24"
            to="/helpdesk/5e9f516d2c7d3a7e9aeb5bfe"
          >
            <FontAwesomeIcon className="text-32 tablet:text-40" icon={faGift} />
            <FaqTitle>Order Information</FaqTitle>
          </Link>
          <Link
            className="bg-grey-10 tablet:flex-col tablet:gap-24 tablet:py-80 flex items-center justify-center gap-8 py-24"
            data-lc="return-policy"
            to="/helpdesk/5e9f517e04286364bc98bf37"
          >
            <FontAwesomeIcon className="text-32 tablet:text-40" icon={faGem} />

            <FaqTitle>Jewelry Education</FaqTitle>
          </Link>
        </div>
      </div>
    </>
  )
}
export default ReturnPolicy
